module.exports = __webpack_public_path__ + "img/score5.d7fff1c3.png";